module.exports = __webpack_public_path__ + "img/vector.d6ff515d.png";